import { config } from 'api';
import errorHandler from 'utils/errorHandler';

import { isUserLoggedIn } from 'apps/user/helpers';

export const CLEAR_POSTCODE_BANNER = 'CLEAR_POSTCODE_BANNER';
export const FETCH_POSTCODE_BANNER_REQUEST = 'FETCH_POSTCODE_BANNER_REQUEST';
export const FETCH_POSTCODE_BANNER_SUCCESS = 'FETCH_POSTCODE_BANNER_SUCCESS';
export const FETCH_POSTCODE_BANNER_ERROR = 'FETCH_POSTCODE_BANNER_ERROR';
export const TOGGLE_POSTCODE_BANNER_VISIBILITY = 'TOGGLE_POSTCODE_BANNER_VISIBILITY';

const endpointUrl = `${config.apiBasePath}/postcode-banner`;

function requestPostcodeBanner() {
  return {
    type: FETCH_POSTCODE_BANNER_REQUEST,
  };
}

function receivePostcodeBanner(data) {
  return {
    type: FETCH_POSTCODE_BANNER_SUCCESS,
    data,
  };
}

function receivePostcodeBannerError() {
  return {
    type: FETCH_POSTCODE_BANNER_ERROR,
  };
}

export function clearPostcodeBanner() {
  return {
    type: CLEAR_POSTCODE_BANNER,
  };
}

export function togglePostcodeBannerVisibility(isHidden = false) {
  return {
    type: TOGGLE_POSTCODE_BANNER_VISIBILITY,
    isHidden,
  };
}

export function sendClosedPostcodeBannerNotification(bannerId, bannerVersion) {
  return (dispatch, getState, { network }) => (
    network.post(
      `${endpointUrl}/dismiss`,
      {
        body: JSON.stringify({
          docNo: bannerId,
          docVersionNo: bannerVersion,
        }),
      }
    ).catch(errorHandler)
  );
}

export function ensurePostcodeBanner() {
  return (dispatch, getState, { network }) => {
    const state = getState();

    if (!isUserLoggedIn(state.user)) {
      return Promise.resolve();
    }

    const postcodeBannerState = state.header.postcodeBanner;
    if (
      postcodeBannerState &&
      (postcodeBannerState.isReceived || postcodeBannerState.isFetching)
    ) {
      return Promise.resolve(); // already present in the store
    }

    dispatch(requestPostcodeBanner());

    return network.get(endpointUrl)
      .then(content => dispatch(receivePostcodeBanner(content)))
      .catch(err => {
        dispatch(receivePostcodeBannerError());
        errorHandler(err);
      });
  };
}
